import type { Plugin } from "vue";
import type { Router } from "vue-router";
import type { TAppConfig } from "~ui/@application/configs/config-schema.ts";

import * as Sentry from "@sentry/vue";

type TSentryConfigurationPluginOptions = {
  config: TAppConfig;
  router: Router;
};

export const voltexploitSentryonfigurationPlugin = {
  install(app, options: TSentryConfigurationPluginOptions) {
    const { config, router } = options;

    if (config.VITE_SENTRY_ENABLED) {
      return;
    }

    Sentry.init({
      app,
      dsn: config.VITE_SENTRY_DSN,
      environment: config.APP_ENV,
      release: APP_VERSION,
      integrations: [Sentry.browserTracingIntegration({ router })],
      tracesSampleRate: config.VITE_SENTRY_TRACES_SAMPLE_RATE,
      attachStacktrace: true,
      sendDefaultPii: true,
    });
  },
} satisfies Plugin;
